<ds-modal
  [id]="billAccountPaymentsScheduledModal"
  [closeOthers]="true"
  [maxWidth]="500"
  (onCloseModalEvent)="cancel()"
>
  <div class="pad-20">
    <div class="row flex justify-center">
      <span class="heading-sub-section"> Payment reminder </span>
    </div>
    <div class="row margin-top-20">
      <div class="column twelve">
        <p dsContent [contentPath]="'billing.alreadyPaidModal'"></p>
      </div>
    </div>
    <div class="row flex justify-flex-end margin-top-20 items-center">
      <a class="font-weight-semibold margin-right-10" (click)="cancel()">Cancel</a>
      <button ds-button (click)="understand()">Continue</button>
    </div>
  </div>
</ds-modal>
